export enum PaymentProvider {
  NONE = 'None',
  STRIPE = 'Stripe',
  MONEXT = 'Monext',
  PAYPLUG = 'PayPlug',
  ALMA = 'Alma',
  PAYPAL = 'Paypal',
  PURSE = 'Purse',
  CUSTOM = 'Custom',
  ADYEN = 'Adyen',
}
